// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgCallMissedPhoneThick24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<g clipPath="url(#clip0_23405_370236)">
					<path d="M20.27 15.97C20.21 14.64 19.22 13.55 17.9 13.36C17.21 13.27 16.53 13.1 15.89 12.86L15.7 12.8C15.44 12.72 15.18 12.69 14.92 12.69C14.19 12.69 13.5 12.97 12.98 13.49L12.6 13.87C11.34 13.02 10.26 11.95 9.41 10.68L9.79 10.3C10.5 9.59 10.76 8.55 10.48 7.59L10.27 6.99C10.1 6.47 9.98 5.93 9.91 5.38C9.72 4.02 8.54 3 7.18 3H7.15H4.75C3.98 3 3.24 3.33 2.72 3.9C2.2 4.47 1.94 5.24 2.01 6C2.29 8.66 3.21 11.25 4.66 13.48C5.97 15.54 7.76 17.33 9.83 18.64C12.05 20.08 14.62 20.99 17.25 21.28C17.34 21.28 17.43 21.29 17.51 21.29C18.21 21.29 18.87 21.03 19.38 20.57C19.95 20.05 20.28 19.3 20.27 18.53V15.97ZM17.97 18.54C17.97 18.67 17.92 18.8 17.82 18.88C17.74 18.96 17.63 19 17.51 19H17.47C15.21 18.75 12.99 17.96 11.06 16.71C9.24 15.55 7.74 14.05 6.59 12.24C5.33 10.3 4.54 8.07 4.3 5.77C4.29 5.66 4.33 5.53 4.42 5.44C4.51 5.35 4.63 5.29 4.76 5.29H7.17C7.4 5.29 7.6 5.46 7.63 5.68C7.74 6.53 7.95 7.37 8.25 8.18C8.31 8.35 8.27 8.54 8.15 8.66L7.13 9.68C6.77 10.04 6.69 10.61 6.94 11.06C8.18 13.25 10 15.06 12.19 16.31C12.36 16.41 12.56 16.46 12.76 16.46C13.07 16.46 13.36 16.34 13.57 16.12L14.59 15.1C14.67 15.02 14.79 14.97 14.91 14.97C14.97 14.97 15.02 14.97 15.07 15C15.88 15.3 16.73 15.51 17.58 15.63C17.8 15.66 17.97 15.86 17.96 16.09V18.53L17.97 18.54Z" />
					<path d="M22.52 3.96004C22.3 3.74004 22.01 3.62004 21.71 3.62004C21.41 3.62004 21.11 3.74004 20.9 3.96004L17.47 7.39004L15.42 5.34004H16.64C17.27 5.34004 17.79 4.82004 17.79 4.19004C17.79 3.56004 17.27 3.04004 16.64 3.04004H12.64C12.01 3.04004 11.49 3.56004 11.49 4.19004V8.19004C11.49 8.82004 12.01 9.34004 12.64 9.34004C13.27 9.34004 13.79 8.82004 13.79 8.19004V6.97004L16.65 9.83004C16.88 10.06 17.17 10.18 17.47 10.18C17.8 10.17 18.08 10.05 18.28 9.84004L22.52 5.60004C22.74 5.38004 22.86 5.09004 22.86 4.79004C22.86 4.49004 22.74 4.19004 22.52 3.98004V3.96004Z" />
				</g>
				<defs>
					<clipPath id="clip0_23405_370236">
						<rect width={20.86} height={18.3} transform="translate(2 3)" />
					</clipPath>
				</defs>
			</Svg>
		);
	}
);
SvgCallMissedPhoneThick24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgCallMissedPhoneThick24;
